module.exports = __webpack_public_path__ + "img/marker-tree.c9600d13.svg";